var tsPrelanderVariantData = {};

$(document).ready(function () {
  initTsPrelanderVariantData();
  $('.ts-product').each(function () {
    initTsProductPrelanderCard($(this));
  });
  initTsPrelanderSharedSticky();
});

function initTsPrelanderVariantData() {
  var $mapEl = $('.ts-product__variant-data').first();
  try {
    tsPrelanderVariantData = JSON.parse($mapEl.text());
  } catch (e) {
    tsPrelanderVariantData = {};
  }
}

function tsPrelanderCurrentQty() {
  var value = parseInt($('.psa_qty_value').first().text(), 10);
  return value > 0 ? value : 1;
}

function tsPrelanderSetQty(value) {
  $('.psa_qty_value').text(value);
}

function tsPrelanderAddToCart(variantId, $btn) {
  if (!variantId || $btn.hasClass('is-disabled')) return;

  var $loading = $btn.find('.ts-product__loading');
  $btn.addClass('is-loading adding');
  $loading.css('opacity', '1');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    contentType: 'application/json',
    data: JSON.stringify({
      items: [{ id: variantId, quantity: tsPrelanderCurrentQty() }],
      sections: 'cell_cart_drawer',
    }),
    dataType: 'json',
    success: function (data) {
      if (window.refreshCartDrawer) window.refreshCartDrawer(false, data.sections);
      if (window.openCartDrawer) window.openCartDrawer(true);
    },
    error: function (err) {
      console.error('Error:', err);
    },
    complete: function () {
      $btn.removeClass('is-loading adding');
      $loading.css('opacity', '0');
    },
  });
}

function initTsProductPrelanderCard($root) {
  if ($root.data('tsPrelanderInit')) return;
  $root.data('tsPrelanderInit', true);

  var $sectionRoot = $root.closest('.shopify-section');
  var $img = $root.find('.ts-product__gallery-simple img');
  var $atcBtn = $root.find('.ts-product__atc-btn');
  var $shadesInfo = $root.find('.simple-product_shades_info__js');

  function setAtcState(available) {
    $atcBtn.toggleClass('is-disabled', !available);
    $atcBtn.prop('disabled', !available);
    $atcBtn.find('.ts_product-btn-text').text(available ? 'Add to cart' : 'Sold out');
  }

  function selectShade($swatch) {
    $root.find('.simple-product_shade').removeClass('active');
    $swatch.addClass('active');

    $shadesInfo.text($swatch.attr('data-title') || '');

    var data = tsPrelanderVariantData[$swatch.attr('data-id')];
    if (!data) return;

    if (data.image) $img.attr('src', data.image);
    setAtcState(data.available);
  }

  function handleSectionClick(event) {
    var $swatch = $(event.target).closest('.simple-product_shade');
    var $qtyBtn = $(event.target).closest('.psa_qty_change');
    if (!$swatch.length && !$qtyBtn.length) return;
    event.stopPropagation();

    if ($swatch.length) {
      selectShade($swatch);
      return;
    }

    var current = tsPrelanderCurrentQty();
    tsPrelanderSetQty($qtyBtn.attr('data') === 'plus' ? current + 1 : Math.max(1, current - 1));
  }

  $sectionRoot[0].addEventListener('click', handleSectionClick, true);

  $atcBtn.on('click', function (event) {
    event.preventDefault();
    var variantId = $root.find('.simple-product_shade.active').attr('data-id');
    tsPrelanderAddToCart(variantId, $atcBtn);
  });
}

function initTsPrelanderSharedSticky() {
  var $stickyBars = $('.ts-product__sticky-atc');
  if (!$stickyBars.length) return;

  var $sticky = $stickyBars.first();
  $stickyBars.slice(1).remove();

  var $stickyBtn = $sticky.find('.ts-product__sticky-atc-btn');
  var $stickyPrice = $sticky.find('.ts-product__sticky-price');
  var $stickyComparePrice = $sticky.find('.ts-product__sticky-compare-price');

  var activeVariantId = $('.simple-product_shade.active').first().attr('data-id');

  function setStickyState(data) {
    $stickyBtn.toggleClass('is-disabled', !data.available);
    $stickyBtn.prop('disabled', !data.available);
    $stickyBtn.find('.ts_product-btn-text').text(data.available ? 'Add to cart' : 'Sold out');
    if (data.price) $stickyPrice.text(data.price);
    $stickyComparePrice.text(data.compare_at_price || '');
  }

  function handleGlobalShadeClick(event) {
    var $swatch = $(event.target).closest('.simple-product_shade');
    if (!$swatch.length) return;

    activeVariantId = $swatch.attr('data-id');
    var data = tsPrelanderVariantData[activeVariantId];
    if (data) setStickyState(data);
  }

  document.addEventListener('click', handleGlobalShadeClick, true);

  $stickyBtn.on('click', function (event) {
    event.preventDefault();
    tsPrelanderAddToCart(activeVariantId, $stickyBtn);
  });

  function updateStickyVisibility() {
    var $footer = $('footer').first();
    var $atcButtons = $('.ts-product__atc-btn');
    var anyVisible = false;

    $atcButtons.each(function () {
      var rect = this.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        anyVisible = true;
      }
    });

    var footerVisible = $footer.length ? $footer[0].getBoundingClientRect().top < window.innerHeight : false;
    $sticky.toggleClass('visible', !anyVisible && !footerVisible);
  }

  $(window).on('scroll', updateStickyVisibility);
  updateStickyVisibility();
}
